import { render, staticRenderFns } from "./DeBtn.vue?vue&type=template&id=2ddaf0fc&"
import script from "./DeBtn.vue?vue&type=script&lang=js&"
export * from "./DeBtn.vue?vue&type=script&lang=js&"
import style0 from "./DeBtn.vue?vue&type=style&index=0&id=2ddaf0fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports